import {
  Add,
  AddCircleSolid,
  Alert,
  AlertCircle,
  AlertCircleSolid,
  AlertSolid,
  ArrowCw,
  ArrowDownSquare,
  ArrowLeft,
  ArrowRight,
  ArrowUpSquare,
  BarChart,
  BellAlert,
  CalendarWeek,
  Check,
  CheckCircle,
  CheckCircleSolid,
  CheckSquare,
  ChevronDown,
  ChevronDownSquare,
  ChevronRight,
  ChevronRightSquare,
  ChevronUp,
  ChevronUpDown,
  Comment,
  Copy,
  CreditCardsSolid,
  Cross,
  CrossCircleSolid,
  CrossSquare,
  Download,
  DownloadCloudSolid,
  DownloadSolid,
  DragAndroid,
  Edit,
  EllipsisVertical,
  EyeHollow,
  EyeSolid,
  EyeSolidDisabled,
  FileText,
  Filter,
  FilterSquare,
  FlaskSolid,
  FullScreenExit,
  Gear,
  GearSolid,
  GridSolid,
  HomeSolid,
  IconCircleInfo,
  Info,
  InfoCircle,
  InfoSquare,
  LineChart,
  Link,
  LiquidNaturalGasSolid,
  List,
  LockSolid,
  LogOut,
  MailClosedHollow,
  MailClosedSolid,
  MailSendSolid,
  Menu,
  MinusCircleSolid,
  MoonSolid,
  MuseumSolid,
  Open,
  PasteAltSolid,
  PeopleSolid,
  PersonGearSolid,
  PersonSolid,
  Pin,
  PinRemove,
  ProductSolid,
  QuestionMarkSquare,
  RetailShop,
  RoadSolid,
  Save,
  SaveSolid,
  Search,
  StackChart,
  SunMoon,
  SunSolid,
  SwapHorizontal,
  Teams,
  Time,
  Trash,
  TrashAltSolid,
  TrashClear,
  TrashClearSolid,
  TrashSolid,
  TruckSolid,
  Tv,
  TvSolid,
  UploadCloud,
  ZoomIn,
  ZoomOut,
} from '@sede-enterprise/shell-ds-react-framework/build/esm/components/Icon/components';

const IconExport = {
  Add,
  AddCircleSolid,
  Alert,
  AlertCircle,
  AlertCircleSolid,
  AlertSolid,
  ArrowCw,
  ArrowDownSquare,
  ArrowLeft,
  ArrowRight,
  ArrowUpSquare,
  BarChart,
  Bell: BellAlert,
  Time,
  ChevronDownSquare,
  ChevronRightSquare,
  ChevronDown,
  ChevronRight,
  ChevronUp,
  ChevronUpDown,
  CheckCircleSolid,
  CheckCircle,
  Comment,
  Copy,
  Cross,
  CrossSquare,
  CrossCircleSolid,
  CreditCardsSolid,
  Check,
  CheckSquare,
  DeleteIcon: TrashAltSolid,
  Download,
  DownloadSolid,
  DownloadCloudSolid,
  DragAndroid,
  EllipsisVertical,
  Edit,
  EyeHollow,
  EyeSolid,
  EyeSolidDisabled,
  Filter,
  FileText,
  FilterSquare,
  FlaskSolid,
  FullScreenExit,
  GearSolid,
  GridSolid,
  Gear,
  HomeSolid,
  InfoCircle,
  IconCircleInfo,
  InfoSquare,
  LineChart,
  Link,
  List,
  LogOut,
  LockSolid,
  LiquidNaturalGasSolid,
  SunMoon,
  MailClosedHollow,
  MailClosedSolid,
  MailSendSolid,
  MinusCircleSolid,
  Menu,
  MoreInfo: Info,
  MoonSolid,
  MuseumSolid,
  Open,
  PasteAltSolid,
  PeopleSolid,
  Pin,
  PinRemove,
  ProductSolid,
  PersonSolid,
  PersonGearSolid,
  QuestionMarkSquare,
  RetailShop,
  RoadSolid,
  Search,
  StackChart,
  Save,
  SaveSolid,
  SunSolid,
  SwapHorizontal,
  Teams,
  Trash,
  TrashAltSolid,
  TrashSolid,
  TrashClear,
  TrashClearSolid,
  TruckSolid,
  Tv,
  TvSolid,
  UploadCloud,
  ZoomIn,
  ZoomOut,
  CalenderWeek: CalendarWeek,
};

export default IconExport;
